import { Link, useLocation, useNavigate } from 'react-router-dom'
import { images, signUpImages } from '../../services/images.service'
import { loginWithGoogle } from '../../store/slices/user.slice'
import { useDispatch } from 'react-redux'
import { closeNotRegisteredPopup } from '../../store/slices/ui.slice'

export function NotRegistered() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()


  async function onGoogleLogin() {
    try {
      await dispatch(loginWithGoogle()).unwrap()
      dispatch(closeNotRegisteredPopup())
    } catch (err) {
      // השגיאה כבר טופלה בקונטרולר
    }
  }
  return (
    <div className="flex min-h-screen flex-col justify-center items-center gap-4 md:gap-24">
      <img className="w-[300px]" src={images.logo} alt="Logo" />

      <div className="flex flex-col gap-4 items-center">
        <span className="text-2xl">אוהיו נאקמה! 👋</span>
        <h1 className="text-5xl text-white text-center">
          הירשם או התחבר כדי לגשת לכל הפעולות באתר
        </h1>
      </div>

      <div className="flex flex-col md:flex-row gap-4">
        <Link
          state={{ backgroundLocation: location }}
          onClick={() => dispatch(closeNotRegisteredPopup())}
          to="/signup"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="214"
            height="75"
            viewBox="0 0 214 75"
            fill="none"
          >
            <g filter="url(#filter0_d_137_2595)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.69482 16.9321C3.90761 17.0179 4.12071 17.1081 4.33399 17.2032C5.65868 17.7901 7.45449 18.8785 8.02886 20.163C7.50094 17.632 6.51442 15.4781 4.59816 13.7545C5.90446 14.8555 7.61615 15.6283 9.33933 16.4064C11.7048 17.4744 14.0919 18.5523 15.4819 20.5021C16.0133 21.2551 16.3148 21.9583 16.3494 22.7832C16.4466 18.693 15.4122 12.1607 12.5543 9.18099C14.8655 10.2571 16.6197 11.9885 17.426 14.2551C17.6412 12.262 16.9389 10.5787 16.2222 8.86058L16.2222 8.86057C15.7903 7.82527 15.3531 6.77738 15.1083 5.64154C17.2193 7.1181 19.7462 7.42226 22.0449 6.64207C19.9686 6.90263 18.9552 5.76934 18.194 4H198.109C197.264 4.46571 196.431 4.99026 195.595 5.51647C193.172 7.0418 190.727 8.5811 187.932 8.74173C186.856 8.79889 185.959 8.67781 185.085 8.24979C189.27 10.6128 196.617 13.3206 201.296 12.4176C198.894 13.8899 196.123 14.4984 193.325 13.9598C195.272 15.2615 197.407 15.5689 199.587 15.8826C200.9 16.0716 202.23 16.263 203.543 16.6756C200.838 17.7456 199.117 19.8407 198.646 22.3346C199.914 19.462 202.933 20.1347 206.72 20.9785C207.706 21.1983 208.745 21.4297 209.818 21.6131V50.5836C208.527 50.5374 207.193 50.4351 205.814 50.1945C204.074 49.8952 201.617 49.1485 200.516 47.8186C201.981 50.6141 203.853 52.8372 206.665 54.2891C204.773 53.3855 202.519 52.9819 200.251 52.5756C197.136 52.0179 193.993 51.455 191.719 49.5869C190.847 48.8637 190.26 48.1321 189.943 47.181C191.203 51.9745 194.601 59.2847 198.931 61.9267C195.877 61.3438 193.252 59.8358 191.551 57.4292C191.97 59.8136 193.353 61.571 194.765 63.3646L194.765 63.3647L194.765 63.3648C195.616 64.4456 196.477 65.5395 197.144 66.7916C194.189 65.6841 191.142 66.0632 188.726 67.6393C191.599 66.5226 193.303 68.3403 195.128 71H18.9891C17.2001 70.2848 15.1596 70.245 13.1765 71H13.1206C13.6682 69.9407 14.3787 69.0103 15.0808 68.091C16.2557 66.5526 17.4068 65.0452 17.7308 63.0165C16.319 65.0786 14.1107 66.3884 11.526 66.9177C15.1668 64.6261 17.9554 58.3826 18.962 54.2995C18.7052 55.1104 18.2163 55.7381 17.4856 56.3618C15.5799 57.9733 12.9195 58.4867 10.2832 58.9954C8.36275 59.366 6.4551 59.7342 4.86138 60.5226C7.22852 59.2583 8.78879 57.3501 9.99547 54.9607C9.07885 56.1019 7.00259 56.7636 5.52927 57.0374C4.90747 57.1545 4.29605 57.2382 3.69482 57.2989V16.9321ZM17.7258 63.0084L17.7225 63.02C17.7225 63.02 17.7304 63.0156 17.7321 63.0098L17.7258 63.0084ZM193.322 13.9491L193.334 13.9554C193.334 13.9554 193.324 13.9578 193.318 13.9546L193.322 13.9491ZM191.559 57.421L191.563 57.4349C191.563 57.4349 191.56 57.4334 191.557 57.4309C191.555 57.4288 191.552 57.4259 191.551 57.4227L191.559 57.421ZM17.4185 14.2603L17.4183 14.2484C17.4183 14.2484 17.4248 14.2545 17.4249 14.2604L17.4185 14.2603Z"
                fill="#BD0029"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_137_2595"
                x="-0.00517583"
                y="0.3"
                width="213.524"
                height="74.4"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="1.85" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_137_2595"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_137_2595"
                  result="shape"
                />
              </filter>
            </defs>
            <text
              x="50%"
              y="50%"
              fill="white"
              font-size="18"
              dominant-baseline="middle"
              text-anchor="middle"
              fontFamily="NoaAlef"
            >
              הרשמה
            </text>
          </svg>
        </Link>
        <Link
          state={{ backgroundLocation: location }}
          onClick={() => dispatch(closeNotRegisteredPopup())}
          to="/login"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="208"
            height="67"
            viewBox="0 0 208 67"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.181641 12.9328C0.395819 13.0185 0.610318 13.1087 0.824997 13.2038C2.15862 13.7907 3.96654 14.8791 4.54478 16.1636C4.0133 13.6327 3.02012 11.4787 1.09095 9.75508C2.40606 10.8561 4.12928 11.6289 5.86409 12.407C8.24547 13.475 10.6487 14.5529 12.048 16.5027C12.583 17.2558 12.8866 17.9589 12.9214 18.7838C13.0193 14.6936 11.9779 8.16131 9.10069 5.1816C11.4275 6.25769 13.1935 7.98912 14.0053 10.2557C14.2219 8.26265 13.5149 6.57926 12.7933 4.86119C12.3585 3.82588 11.9184 2.77799 11.6719 1.64215C13.7972 3.11871 16.3412 3.42286 18.6553 2.64268C16.5648 2.90327 15.5446 1.76968 14.7782 0H195.906C195.057 0.465704 194.218 0.990251 193.376 1.51646C190.936 3.04179 188.475 4.5811 185.661 4.74173C184.578 4.79889 183.675 4.67781 182.795 4.24979C187.009 6.61277 194.404 9.32059 199.115 8.41759C196.697 9.8899 193.908 10.4984 191.091 9.95976C193.05 11.2615 195.2 11.5689 197.394 11.8826C198.717 12.0716 200.055 12.263 201.378 12.6756C198.654 13.7456 196.921 15.8407 196.448 18.3346C197.724 15.462 200.763 16.1347 204.576 16.9785C205.569 17.1983 206.614 17.4297 207.695 17.6131V46.5836C206.395 46.5374 205.052 46.4351 203.664 46.1945C201.912 45.8952 199.438 45.1485 198.33 43.8186C199.805 46.6141 201.69 48.8372 204.52 50.2891C202.616 49.3855 200.347 48.9819 198.063 48.5756C194.927 48.0179 191.763 47.455 189.474 45.5869C188.596 44.8637 188.005 44.1321 187.685 43.181C188.954 47.9745 192.375 55.2847 196.734 57.9267C193.659 57.3438 191.017 55.8358 189.305 53.4292C189.726 55.8136 191.119 57.571 192.54 59.3646C193.397 60.4454 194.264 61.5394 194.935 62.7916C191.96 61.6841 188.893 62.0632 186.461 63.6393C189.353 62.5226 191.068 64.3403 192.905 67H15.5788C13.7778 66.2848 11.7235 66.245 9.72709 67H9.67081C10.2221 65.9407 10.9374 65.0103 11.6442 64.091C12.827 62.5526 13.9859 61.0452 14.312 59.0165C12.8907 61.0786 10.6675 62.3884 8.06542 62.9177C11.7308 60.6261 14.5382 54.3826 15.5516 50.2995C15.293 51.1104 14.8008 51.7381 14.0652 52.3618C12.1466 53.9733 9.46829 54.4867 6.81426 54.9954C4.88084 55.366 2.96033 55.7342 1.35586 56.5226C3.73896 55.2583 5.30975 53.3501 6.52457 50.9607C5.60176 52.1019 3.51151 52.7636 2.02825 53.0374C1.40233 53.1545 0.786858 53.2381 0.181641 53.2989V12.9328ZM14.3069 59.0091L14.3036 59.0207C14.3036 59.0207 14.3116 59.0163 14.3132 59.0105L14.3069 59.0091ZM191.087 9.9491L191.099 9.95538C191.099 9.95538 191.09 9.95774 191.084 9.9546L191.087 9.9491ZM189.313 53.4211L189.317 53.435C189.317 53.435 189.307 53.4298 189.305 53.4228L189.313 53.4211ZM13.9975 10.261L13.9973 10.249C13.9973 10.249 14.0039 10.2551 14.004 10.2611L13.9975 10.261Z"
              fill="#5B0014"
            />
            <text
              x="50%"
              y="50%"
              fill="white"
              font-size="18"
              dominant-baseline="middle"
              text-anchor="middle"
              fontFamily="NoaAlef"
            >
              התחברות
            </text>
          </svg>
        </Link>
      </div>

      {/* מחלק */}
      <div className="w-[320px] md:w-[520px]">
        <img className="mb-4 w-full" src={signUpImages.divider} alt="Divider" />

        {/* התחברות דרך צד שלישי */}
        <div className="flex justify-center w-full">
          <button
            onClick={onGoogleLogin}
            className="flex items-center justify-center w-full gap-3 px-4 py-2 border border-primary hover:scale-105 transition-transform"
          >
            <img
              src={signUpImages.googleIcon}
              alt="Google sign up"
              className="w-6 h-6"
            />
            <span className="text-primaryText">התחברות עם גוגל</span>
          </button>
        </div>
      </div>
    </div>
  )
}
